/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PlatformAdminUIState, PlatformAdminUIThunkType } from '../../store/store';
import { getPushEvents } from './store/PushEvent.actions';
import PushEventListView from './PushEventList.view';
import { RouteComponentProps } from 'react-router-dom';
import { PushEventActionTypes } from './store/PushEventActionTypes';
import { ListPushEvent } from './store/PushEvent.state';

interface Props extends RouteComponentProps {
	pushEvents: ListPushEvent[];
	loading: boolean;
	getPushEvents: () => void;
}

class PushEventListContainer extends Component<Props> {
	componentDidMount(): void {
		this.props.getPushEvents();
	}

	render(): JSX.Element {
		const { pushEvents, loading } = this.props;
		return <PushEventListView pushEvents={pushEvents} loading={loading} />;
	}
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (state: PlatformAdminUIState) => {
	return {
		pushEvents: state.pushEvent.list.pushEvents,
		loading: state.pushEvent.list.loading
	};
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapDispatchToProps = (dispatch: PlatformAdminUIThunkType<PushEventActionTypes>) => {
	return {
		getPushEvents: (): Promise<void> => dispatch(getPushEvents())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(PushEventListContainer);
